import React from 'react';
import './careers.css';

function Careers() {
  return (
    <div className='mainCarousel'>
        This is the Careers
    </div>
  );
}

export default Careers;